import React, {useMemo, useRef, useState} from 'react'
import InfoTooltip from "../../components/InfoTooltip.js";
import TalentMatchDetails from "./TalentMatchDetails";
import {useAuth} from "../../providers/AuthProvider";
import {useCandidate} from "../../providers/CandidateProvider";
import {usePosition} from "../../providers/ProjectPositionProvider";
import {useProject} from "../../providers/ClientProjectProvider";
import {Img} from "react-image";
import LoadingSpinner from "../../components/LoadingSpinner";
import {Link, useSearchParams} from "react-router-dom";
import {Badge as AntdBadge, Checkbox, Dropdown} from "antd";
import UserImageCircle, { UserImageCircleNEW } from "../../components/UserImageCircle";
import ClientPreferredRateModal from "./ClientPreferredRateModal";
import TalentTileBadges from './TalentTileBadges.js';
import CandidateFitTabs from './CandidateFitTabs.js';
import CandidateActions from "./CandidateActions";
import HideTalentPricingTooltip from '../clients/HideTalentPricingTooltip.js';
import TalentDisplayName from '../../components/TalentDisplayName.js';

const CandidateStatusActions = ({onCandidateAction, shortlistView, isDisabled, ...props}) => {

    const {project, bulkActions} = useProject();
    const actionContainerRef = useRef(null)
    const {position} = usePosition();
    const {auth} = useAuth();
    const {
        candidate,
        showCandidateProposal,
        canArchive,
        removeFromArchive,
        addToArchive,
        canFavorite,
        removeFromLiked,
        addToLiked,
        removeFromFavorites,
        canRunBulkActions,
        onAddToBulkActions,
        isBulkActionsSelected,
        addToFavorites,
        canMessage,
        canInterview,
        isDisabled: isCandidateActionDisabled,
        overrideClientPreferredRate
    } = useCandidate();
    const [isClientPreferredRateOpen, setIsClientPreferredRateOpen] = useState(false)
    const [rate, setRate] = useState(candidate.standardPlatformRate(false));

    const tooltipId = `${candidate?.id}-${position.id || 'browse'}`
    const archiveId = "arch-btn-" + tooltipId;
    const favoriteId = "fav-btn-" + tooltipId;
    const removeId = "rem-btn-" + tooltipId;

    const userLikes = candidate.job_candidate?.likes || [];
    const otherUserLikes = TB.filter(userLikes, like => like.causer?.id !== auth.id);
    return (
        <div className="candidate-status-actions relative" ref={actionContainerRef}>

            <div className="flex flex-row items-center mr-auto h-8 justify-start relative w-[65px] z-10">
                {!shortlistView && canArchive && (
                    <React.Fragment>
                        {!bulkActions?.length && (
                            <button
                                className={TB.mapClass("btn archive-btn", {"pl-0": canRunBulkActions})}
                                style={styles.archiveBtn}
                                onClick={() => onCandidateAction(
                                    candidate.wasDisliked() ?
                                        removeFromArchive :
                                        addToArchive
                                )}
                                id={archiveId}
                                disabled={isDisabled || bulkActions?.length > 0}>
                                <i className={candidate.wasDisliked() ? "fas fa-plus-circle" : "fas fa-times-circle"}/>
                            </button>
                        )}

                        {canRunBulkActions && !candidate.wasDisliked() && (
                            <Checkbox
                                checked={isBulkActionsSelected}
                                onChange={async (e) => {
                                    onAddToBulkActions()
                                }}
                                className="archive-checkbox ml-2"
                            />
                        )}
                        {!bulkActions?.length && (
                            <InfoTooltip key={archiveId + 'tooltip'} type={"dark"} target={archiveId}>
                                {candidate.wasDisliked() ? "Remove from archive" : "Archive"}
                            </InfoTooltip>
                        )}

                    </React.Fragment>
                )}
            </div>

            <div
                className="flex-grow flex flex-row h-8 absolute left-0 right-0 flex-nowrap justify-center gap-1.5 items-center mb-1">
                {candidate.supplier_client?.id ? (
                    <React.Fragment>
                        <div className="whitespace-nowrap text-xxs self-center text-right">
                            Agency:
                        </div>
                        <Link target="_blank" to={`/agency-profiles/${candidate.supplier_client.id}`}
                              className="flex gap-1 items-center justify-start">
                            <img src={candidate.supplier_client.logo_path} className="h-8 img-fluid max-w-full"/>
                        </Link>
                    </React.Fragment>
                ) : (
                    <div className="whitespace-nowrap flex-1 text-xxs self-center text-center">
                        Freelancer
                    </div>
                )}
            </div>
            <div className="flex flex-row items-center h-8 justify-end w-[65px] ml-auto z-10">
                {!shortlistView && canFavorite && (
                    <React.Fragment>
                        {(!bulkActions?.length || candidate.wasLiked()) && (
                            <React.Fragment>
                                <AntdBadge count={otherUserLikes?.length ? userLikes.length : 0} size="large"
                                           className="ml-auto mr-[-2px]">
                                    <button
                                        className="btn like-btn"
                                        style={styles.favoriteBtn}
                                        onClick={() => onCandidateAction(
                                            candidate.wasLiked() ?
                                                removeFromLiked :
                                                addToLiked
                                        )}
                                        id={favoriteId}
                                        disabled={isDisabled || bulkActions?.length > 0}>
                                        <i className={TB.mapClass("fa-thumbs-up", {
                                            "fas": candidate.wasLiked(),
                                            "far": !candidate.wasLiked(),
                                            "text-success": !!userLikes.length
                                        })}/>

                                    </button>
                                </AntdBadge>


                                <InfoTooltip type="dark" placement={!!otherUserLikes?.length ? 'bottom' : 'top'}
                                             target={favoriteId}>
                                    <div className="px-0 py-1.5 text-left flex flex-col items-start gap-1">
                                        {!!otherUserLikes?.length ? (
                                            TB.orderBy(
                                                TB.map(userLikes, like => {
                                                    if (!like.causer) return null;

                                                    return (
                                                        <p className="text-xxs font-medium p-0 text-white gap-1 flex flex-row items-center"
                                                           key={like.id}>
                                                            <span>{`${like.causer.first_name} ${like.causer.last_name}`}</span>
                                                            {like.causer.id === auth.id &&
                                                                <span className="italic text-red-400">(You)</span>}
                                                            {/*<span className="font-light italic underline">{TB.moment(like.created_at).fromNow()}</span>*/}
                                                        </p>
                                                    )
                                                }), like => like.causer?.id === auth.id ? 1 : 0, 'desc')
                                        ) : (
                                            <p className="font-medium text-xxs p-0 text-white">
                                                {candidate.wasLiked() ? 'Unlike' : 'Like'}
                                            </p>
                                        )}
                                    </div>
                                </InfoTooltip>
                            </React.Fragment>
                        )}
                        {!bulkActions?.length && (
                            <Dropdown
                                getPopupContainer={actionContainerRef ? () => actionContainerRef?.current : undefined}
                                trigger={['click']}
                                placement="bottomRight"
                                className="cursor-pointer"
                                menu={{
                                    items: [
                                        {
                                            key: 'favorite',
                                            icon: <i
                                                className={"text-danger mr-2 fa-heart " + (candidate.is_favorite ? "fas" : "far")}/>,
                                            label: (
                                                <span className="whitespace-nowrap">
                                                    {candidate.is_favorite ? "Remove from saved" : "Save as Favorite"}
                                                </span>
                                            ),
                                            onClick: async ({item, key, keyPath, domEvent}) => {
                                                await TB.wait(200)
                                                onCandidateAction(candidate.is_favorite ? removeFromFavorites : addToFavorites)
                                            }
                                        },
                                        ...((auth.isClientManager() || auth.isClientConsultant()) ? [
                                            ...(candidate?.email ? [
                                                {
                                                    key: 'email',
                                                    icon: <i className="fas fa-envelope"/>,
                                                    label: (
                                                        <a href={`mailto:${candidate.email}?subject=${encodeURIComponent(`Message from Wripple Client Lead regarding ${position.title} Opportunity with ${auth.client_organization.name}`)}`}>
                                                            {candidate.email}
                                                        </a>
                                                    ),
                                                }
                                            ] : []),
                                            ...(candidate?.phone ? [
                                                {
                                                    key: 'call',
                                                    icon: <i className="fas fa-phone"/>,
                                                    label: (
                                                        <a href={`tel:${candidate.phone}`}>
                                                            {candidate.phone}
                                                        </a>
                                                    ),
                                                }
                                            ] : []),
                                            {
                                                key: 'set-rate',
                                                icon: <i className="fas fa-dollar-sign"/>,
                                                label: (
                                                    <span className="whitespace-nowrap">Set Client Preferred Rate</span>
                                                ),
                                                onClick: (e) => {
                                                    return setIsClientPreferredRateOpen(true)
                                                },
                                                disabled: isDisabled
                                            },
                                            ...(candidate?.client_override_hourly_rate ? [
                                                {
                                                    key: 'delete-rate',
                                                    icon: <i className="fas fa-eraser"/>,
                                                    label: (
                                                        <span className="whitespace-nowrap">Remove Client Preferred
                                                            Rate</span>
                                                    ),
                                                    onClick: async (e) => {

                                                        let confirm = await TB.alert("warning", "Remove Client Preferred Rate",
                                                            "Are you sure you want to remove this talent's preferred rate for this client?",
                                                            [
                                                                {title: 'Yes, Continue'},
                                                                {title: 'Cancel'}
                                                            ])
                                                        if (confirm) {
                                                            return overrideClientPreferredRate(false, project, position)
                                                        }
                                                    },
                                                    disabled: isDisabled
                                                },
                                            ] : [])
                                        ] : []),
                                    ],
                                }}
                            >
                                <i className="fas fa-ellipsis-v ml-2"/>
                            </Dropdown>
                        )}
                    </React.Fragment>
                )}

                {!project.isActive() && shortlistView && canMessage && !project?.hasRequestedSOW() && !bulkActions?.length && (
                    <React.Fragment>
                        <AntdBadge count={candidate.unreadMessageCount()} size="small">
                            <button
                                className="btn message-btn"
                                disabled={bulkActions?.length > 0}
                                onClick={() => showCandidateProposal()}
                            >
                                <i className="far fa-comment-alt" />
                            </button>
                        </AntdBadge>
                    </React.Fragment>
                )}
                {!project.isActive() && shortlistView && canInterview && !project?.hasRequestedSOW() && !bulkActions?.length && (
                    <React.Fragment>
                        <AntdBadge count={candidate.hasInterviewUpdateSinceLastViewed() ? '!' : null} size="small">
                            <button
                                className="btn message-btn"
                                disabled={bulkActions?.length > 0}
                                onClick={() => showCandidateProposal('&tabView=interviews')}
                            >
                                <i className="far fa-calendar-alt"/>
                            </button>
                        </AntdBadge>

                    </React.Fragment>
                )}
            </div>
            {!bulkActions?.length && (auth.isClientManager() || auth.isClientConsultant()) && (
                <ClientPreferredRateModal
                    isDisabled={isDisabled}
                    onClose={setIsClientPreferredRateOpen}
                    isOpen={isClientPreferredRateOpen}/>
            )}
        </div>
    )
}

const CandidateTile = ({children, ...props}) => {
    const {
        candidate,
        permissionToInvite,
        removeFromCandidates,
        showCandidateProposal,
        matchingDisciplines,
        canArchive,
        onAddToBulkActions,
        isBulkActionsSelected,
        canRunBulkActions,
        removeFromArchive,
        addToArchive,
    } = useCandidate();

    const {project} = useProject()
    const {position} = usePosition();
    const {auth} = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const tooltipId = `${candidate?.id}-${position.id || 'browse'}`
    const archiveId = "aarch-btn-" + tooltipId;

    const detailLink = useMemo(() => {
        let params = new URLSearchParams(searchParams);
        if (position) {
            params.set('role', position?.id);
        }
        return {
            pathname: `talent-profiles/${candidate.id}`,
            search: params.size > 0 ? `?${params.toString()}` : undefined
        }
    }, [position?.id, searchParams?.toString()])

    const showMatchDetails = () => {
        let criteria = {};
        if (props.criteria) {
            criteria = props.criteria;
        } else if (candidate || position) {
            criteria = {...(candidate || {}), ...(position || {})};
        }
        return TB.event('Modal@show', {
            modalClass: 'match-details-modal',
            content: (
                <TalentMatchDetails
                    talent={candidate}
                    projectId={project?.id}
                    positionId={position?.id}
                    isEngagementLead={false}
                    criteria={criteria}
                />
            )
        })
    }

    const onCandidateAction = async (request) => {
        let update = await props.onRequest(request);
        if (update && props.onUpdated) {
            await props.onUpdated(update);
        }
    }

    const imageSrc = useMemo(() => {
        if (candidate?.image_path && String(candidate?.image_path).includes('default-user')) {
            return null;
        }
        return candidate?.image_path || TB.defaultUserProfileImagePath()
    }, [candidate?.id])


    if (props.placeholder) {
        return <CandidateTileSkeleton hideAvailability={props.hideAvailability}>{children}</CandidateTileSkeleton>;
    }
    const removeId = `rem-btn-${candidate?.id}-${position.id || 'browse'}`


    return (
        <div className={TB.mapClass("candidate-panel", {
            assigned: candidate.isAssigned(),
            selected: isBulkActionsSelected,
            'bulk-enabled': canRunBulkActions
        })}>

            <div className={TB.mapClass("candidate-status-header", {
                "interested": candidate.matchStatusIsInterested(),
                "shortlisted": candidate.shortlistedAccepted(),
                "pending": candidate.isPendingShortlisted(),
                "declined": candidate.declinedPosition(),
            })}>
                {candidate.hasProposalForClient() ? (
                    <p>
                        Availability: {candidate?.availableStartDate()}
                    </p>
                ) : (
                    <React.Fragment>


                        {(candidate.declinedPosition()) && (
                            <p className="archive-and-remove">
                                {candidate.statusIsWithdrawn() && "No Longer Interested"}

                                {candidate.statusIsRejected() && "Not Interested"}

                                {!project.isActive() && candidate.declinedPosition() && !candidate.job_candidate?.was_disliked && (
                                    <React.Fragment>
                                        <i className="mx-1 p-1 clickable fa fa-times"
                                           id={removeId}
                                           disabled={props.isDisabled}
                                           onClick={() => {
                                               if (!permissionToInvite) {
                                                   return TB.showPermissionError();
                                               }
                                               return onCandidateAction(removeFromCandidates)
                                           }}/>

                                        <InfoTooltip
                                            type="dark"
                                            placement="top"
                                            target={removeId}>
                                            Remove from candidates and archive from talent list
                                        </InfoTooltip>
                                    </React.Fragment>
                                )}
                            </p>

                        )}

                    </React.Fragment>
                )}

                {candidate.hasProposalForClient() ? (
                    <React.Fragment>

                        {candidate.hasUnseenProposalUpdate() &&
                            <i className="fa fa-circle ml-auto mr-2 text-danger"/>}

                        <button className="btn btn-link-dark" onClick={() => showCandidateProposal()}>
                            View Proposal
                        </button>
                    </React.Fragment>
                ) : (
                    candidate.statusIsPending() && <p className="!mx-auto text-bold">Proposal Requested</p>
                )}

            </div>


            <div className="pt-2">

                <div className="px-4">
                    <CandidateStatusActions
                        isDisabled={props.isDisabled}
                        shortlistView={props.shortlistView}
                        onCandidateAction={onCandidateAction}
                    />

                    <div className="candidate-top-contents">

                        <div className="content-ro flex flex-col items-center">
                            {/* <div className="candidate-card-image">
                                <Img
                                    loader={<div className="loading-user-image"><LoadingSpinner size="lg"/></div>}
                                    src={imageSrc}
                                    unloader={<UserImageCircle user={candidate} hideTooltip={true} size={105}/>}
                                    className="img-fluid img-grayscale"
                                />

                                {candidate.statusImage() && (
                                    <img alt="" src={candidate.statusImage()} className="candidate-img-status"/>
                                )}
                            </div> */}
                            {/* <div className="candidate-card-image">
                                <UserImageCircle user={candidate} hideTooltip={true} size={105} />
                            </div> */}
                            <div className="bg-green200">
                                <UserImageCircleNEW
                                    user={candidate}
                                    className="!h-[105px] !w-[105px]"
                                    statusImage={candidate.statusImage()}
                                    showAvailabilityDot={false}
                                />
                            </div>
                            <div className="candidate-name text-center mt-3">
                                <div>
                                    <TalentDisplayName talent={candidate}>
                                        <h5 className="mb-0 line-clamp-1">
                                            {candidate.firstNamePlusInitial()}
                                            {!props.shortlistView && candidate.is_new && <AntdBadge count="NEW" className="ml-2" status="error" />}
                                        </h5>
                                    </TalentDisplayName>
                                    {candidate.fullJobTitle() && (
                                        <p className="job-title mx-auto text-xxs">
                                            {candidate.fullJobTitle()}
                                        </p>
                                    )}
                                </div>

                                {candidate.location && (
                                    <p className="mb-0">
                                        <i className="fa fa-map-marker-alt mr-1"/>
                                        {candidate.location.city}{!!candidate.location.state && `, ${candidate.location.state}`}
                                    </p>
                                )}
                            </div>

                        </div>

                        <div className="content-col">
                            {/* <p>{matchingDisciplines?.length || '0'}/{position?.disciplines.length || '0'} Matched Roles</p> */}
                            <div className="matched-roles">
                                {TB.map(TB.first(TB.chunk(matchingDisciplines, 2)), discipline => (
                                    <p className={TB.mapClass("role2", {
                                        'max-w-[234px]': matchingDisciplines?.length === 1,
                                        'max-w-[135px]': matchingDisciplines?.length === 2
                                    })} key={`r-${discipline.id}`}>
                                        {discipline.name}
                                    </p>
                                ))}
                                {matchingDisciplines?.length > 2 && (
                                    <>
                                        <p id={`matched-roles-${candidate.id}`}
                                           className="more-roles">+ {TB.pluralize('role', matchingDisciplines?.length - 2, true)}</p>
                                        <InfoTooltip
                                            type="dark"
                                            placement="top"
                                            target={`matched-roles-${candidate.id}`}
                                        >
                                            {matchingDisciplines.slice(2).map(discipline => {
                                                return <p key={discipline.id}
                                                          className="px-3 py-1 m-0 text-white text-left">{discipline.name}</p>
                                            })}
                                        </InfoTooltip>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className="content-col text-center">
                            <p className="line-clamp candidate-bio">
                                {candidate.fullBio() || ''}
                            </p>
                            <Link className="details-link"
                                  to={detailLink}>
                                View Profile
                            </Link>
                        </div>
                    </div>

                    <hr className="m-0 mt-2"/>

                    {candidate?.hasMatching() && (
                        <div className="talent-matching relative">
                            <div className="metric-container flex-col items-center self-center gap-3">
                                <CandidateFitTabs
                                    candidate={candidate}
                                    onShowMatchDetails={showMatchDetails}
                                />
                            </div>
                            <TalentTileBadges/>
                        </div>
                    )}
                </div>


                {candidate.isAssigned() ? (
                    (candidate.isFixedFee() || candidate.isFixedRetainer()) ? (
                        <div className="candidate-rate-section">
                            <h4>Accepted Cost</h4>
                            {/* <h2>
                            <span>{candidate.proposedPlatformRate()}/hr</span>
                        </h2> */}
                            {auth.canViewTalentPricing() ? (
                                <h2 className="currency-sup">
                                    {candidate.proposedPlatformCost()}
                                    <span>/hr</span>
                                </h2>
                            ) : (
                                <h2>
                                    <HideTalentPricingTooltip />
                                </h2>
                            )}
                        </div>
                    ) : (
                        <div className="candidate-rate-section">
                            <h4>Accepted Rate</h4>
                            {/* <h2>
                            <span>{candidate.proposedPlatformRate()}/hr</span>
                        </h2> */}
                            {auth.canViewTalentPricing() ? (
                                <h2 className="currency-sup">
                                    {candidate.rangedPlatformRates()}
                                    <span>/hr</span>
                                </h2>
                            ) : (
                                <h2>
                                    <HideTalentPricingTooltip />
                                </h2>
                            )}
                        </div>
                    )
                ) : ((candidate.isFixedFee() || candidate.isFixedRetainer()) && candidate.hasProposalForClient() && !candidate.statusIsPending()) ? (
                    (
                        <div className="candidate-rate-section">

                            <h4>
                                Proposed Cost
                            </h4>
                            {auth.canViewTalentPricing() ? (
                                <>
                                    {candidate.isFixedRetainer() ? (
                                        <React.Fragment>
                                            {(candidate.hasProposalForClient() && candidate.hasSubmittedProposal() && candidate.isFixedRetainerProposalValid(position.isFixedRetainerRateBased())) ? (
                                                <h2 className="currency-sup">
                                                    {candidate.proposedPlatformPayoutPerPeriod(position.isFixedRetainerRateBased())}
                                                    <span>
                                                        /{position.payout_frequency === 'weekly' ? 'wk' : 'mth'}
                                                    </span>
                                                </h2>
                                            ) : (
                                                <h2>
                                                    <span className="italic">Pending</span>
                                                </h2>
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {candidate.hasSubmittedProposal() ? (
                                                <h2 className="currency-sup">
                                                    {candidate.proposedPlatformCost()}
                                                    {candidate.isFixedFee() && (
                                                        <span className="pl-1.5">fixed fee</span>
                                                    )}
                                                </h2>
                                            ) : (
                                                <h2>
                                                    <span className="italic">Pending</span>
                                                </h2>
                                            )}
                                        </React.Fragment>
                                    )}
                                </>
                            ) : (
                                <h2>
                                    <HideTalentPricingTooltip />
                                </h2>
                            )}
                        </div>
                    )
                ) : (
                    <div className={TB.mapClass("candidate-rate-section", {
                        "rate-change": candidate.changedHourlyRate(),
                        "preferred-candidate-rate": !candidate.changedHourlyRate() && candidate.client_override_hourly_rate
                    })}>
                        {candidate.isTimeMaterials() && candidate.changedHourlyRate() && (
                            <div className="rate-change-container">
                                <h4>
                                    {candidate.client_override_hourly_rate ? "Preferred Rate" : "Standard Rate"}
                                </h4>
                                {auth.canViewTalentPricing() ? (
                                    <h2>
                                        <span>{candidate.standardPlatformRate()}/hr</span>
                                    </h2>
                                ) : (
                                    <h2>
                                        <HideTalentPricingTooltip />
                                    </h2>
                                )}
                            </div>
                        )}
                        <div id={`talent-rate-type-${candidate.id}`} className="select-none">
                            <h4>
                                {(candidate.isTimeMaterials() && candidate.changedHourlyRate()) ? 'Proposed Rate' : (
                                    candidate.client_override_hourly_rate ? "Preferred Rate" : "Standard Rate"
                                )}
                            </h4>

                            {auth.canViewTalentPricing() ? (
                                <h2 className="currency-sup">
                                    {(candidate.isTimeMaterials() && candidate.changedHourlyRate()) ?
                                        candidate.proposedPlatformRate() :
                                        candidate.standardPlatformRate()
                                    }
                                    <span>/hr</span>
                                </h2>
                            ) : (
                                <h2>
                                    <HideTalentPricingTooltip />
                                </h2>
                            )}
                        </div>
                        {candidate.client_override_hourly_rate && !candidate.changedHourlyRate() && (
                            <InfoTooltip target={`talent-rate-type-${candidate.id}`} type="dark" placement="top">
                                <p className="text-xs text-white italic py-1 px-2" style={{textTransform: 'none'}}>
                                    This candidate offers a preferred rate for your organization
                                </p>
                            </InfoTooltip>
                        )}
                    </div>
                )}

                {children || (
                    <CandidateActions
                        hideRates={true}
                        onRequest={props.onRequest}
                        onCandidateAction={onCandidateAction} isDisabled={props.isDisabled}/>
                )}
            </div>

        </div>
    )
}

const CandidateTileSkeleton = ({children, ...props}) => {
    return (
        <div className="talent-panel candidate-panel potential-talent-panel relative">

            {props.hideAvailability && <div className="candidate-status-header"/>}

            <div className="flex flex-col items-center gap-2 p-4">
                <div className="skeleton h-3 w-1/5"/>

                <div className="skeleton rounded-full h-[105px] w-[105px]"/>

                <div className="skeleton h-5 w-1/2"/>
                <div className="skeleton h-3 w-1/5 mt-1"/>
                <div className="skeleton h-3 w-1/6"/>

                <div className="flex gap-3 w-5/6">
                    <div className="skeleton h-6 w-full"/>
                    <div className="skeleton h-6 w-full"/>
                </div>

                <div className="skeleton h-10 w-11/12 mt-2"/>

                <div className="skeleton h-3 w-1/5"/>

                {/* <div className="h-px bg-black w-full" /> */}
                <hr className="border-wrippleLightGrayBg w-full"/>

                <div className="skeleton rounded-full h-28 w-28 flex items-center justify-center">
                    <div className="bg-white rounded-full h-24 w-24"/>
                </div>

                <div className="skeleton h-3 w-1/5"/>

            </div>

            <div className="candidate-rate-section items-center">
                <div className="skeleton h-5 mb-2 w-1/3"/>
                <div className="skeleton h-4 w-1/5"/>
            </div>

            {/* <div className="h-[120px] flex items-center justify-center px-5">
                <div className="skeleton-purple h-9 w-full"></div>
            </div> */}
            {children}
        </div>
    )
}

export default CandidateTile;

export {
    CandidateTileSkeleton
}

const styles = {
    favoriteBtn: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },

    archiveBtn: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    inviteLockIcon: {
        position: 'absolute',
        fontSize: 13,
        right: -18,
    }
};